import type { IssueKey } from '@atlassian/jira-shared-types/src/general.tsx';

const extractKeyNumPart = (key: IssueKey): number => +key.substring(key.indexOf('-') + 1);

const extractProjectPart = (key: IssueKey): string => key.substring(0, key.indexOf('-'));

export const issueKeyComparator = (issueKey1: IssueKey, issueKey2: IssueKey): number =>
	extractProjectPart(issueKey1).localeCompare(extractProjectPart(issueKey2)) ||
	extractKeyNumPart(issueKey1) - extractKeyNumPart(issueKey2);
